(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.newsSlider = {
    attach: function(context, settings) {
      jQuery('.view-in-the-news .view-content', context).once('card-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
        nextArrow: '<button type="button" class="slick-next">&gt;</button>'
      });
    }
  };

  Drupal.behaviors.artifactSlider = {
    attach: function(context, settings) {
      jQuery('.field--name-field-artifact-items', context).once('card-carousel').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
        nextArrow: '<button type="button" class="slick-next">&gt;</button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '20px'
            }
          }
        ]
      });
    }
  };

  Drupal.behaviors.mastheadSlider = {
    attach: function(context, settings) {
      jQuery('.views-field-field-masthead-image .field-content', context).once('card-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: 'linear',
        arrows: false
      });
    }
  };

})(jQuery, Drupal);
